import { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../components/ui/sheet";

const TEAM = [
  {
    name: "Aradhana Chatterjee",
    role: "Founder & Storyteller",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/i5ftzti9_Aradhana.JPG",
  },
  {
    name: "Joydeep Sen",
    role: "Strategy & Growth",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/anaov0k4_DSC_0241.JPG",
  },
  {
    name: "Abhijit Das",
    role: "Editor",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/1ngb5426_Abhijit.JPG",
  },
  {
    name: "Nilendu Gharami",
    role: "Admin",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/9u0anl31_Nilendu.JPG",
  },
  {
    name: "Aranya Adhikary",
    role: "Writer",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/u2zn7xmx_Aranya.JPG",
  },
  {
    name: "Vishal Khan",
    role: "Production Assistant",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/9j1qypap_Vishal.JPG",
  },
  {
    name: "Bipplab Ghosh",
    role: "Post-Production Supervisor",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/o5sa88t5_Bipplab.JPG",
  },
  {
    name: "Darakshah Sohail",
    role: "Creative",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/ublga8ts_Darakshah.JPG",
  },
  {
    name: "Rajesh Samanta",
    role: "Documentary Editor",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/gxeaqwuz_Rajesh.JPG",
  },
  {
    name: "Kamalika Biswas",
    role: "Design",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/vtj5k3rd_Kamalika.JPG",
  },
  {
    name: "Sucheta Nandi",
    role: "Finance",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/p2j05zgu_Sucheta.JPG",
  },
  {
    name: "Rashida Mondal",
    role: "Show Editor",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/9qaqex5j_Rashida.JPG",
  },
  {
    name: "Sayan Mondal",
    role: "Director of Photography",
    img: "https://customer-assets.emergentagent.com/job_landing-site-10/artifacts/vfw25ky2_Sayan.JPG",
  },
];

const TILES = [
  { bg: "#f9d94b", fg: "#1a1a1a" }, // mustard
  { bg: "#2d4a22", fg: "#fdfbf7" }, // foundation green
  { bg: "#1a1a1a", fg: "#fdfbf7" }, // ink
  { bg: "#f4efe6", fg: "#1a1a1a" }, // cream
];

const initials = (name) =>
  name
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

export default function TeamPanel() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating vertical tab — right edge */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="team-floating-tab"
        aria-label="Open our team"
        style={{
          writingMode: "vertical-rl",
          transform: "translateY(-50%) rotate(180deg)",
        }}
        className="fixed right-0 top-1/2 z-40 bg-[#1a1a1a] text-[#fdfbf7] px-3 py-6 font-mono text-[11px] tracking-[0.3em] uppercase hover:bg-[#2d4a22] transition-colors shadow-lg cursor-pointer"
      >
        Our Team
      </button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="right"
          data-testid="team-panel"
          className="w-full sm:max-w-md bg-[#fdfbf7] text-[#1a1a1a] border-l border-black/10 overflow-y-auto p-0"
        >
          <div className="px-6 md:px-8 py-8">
            <SheetHeader>
              <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#1a1a1a]/60 text-left">
                The people behind the stories
              </p>
              <SheetTitle className="text-left font-serif text-3xl md:text-4xl tracking-tight text-[#1a1a1a] leading-[1.05]">
                Our team.
              </SheetTitle>
            </SheetHeader>

            <ul className="mt-10 space-y-10">
              {TEAM.map((m, idx) => {
                const t = TILES[idx % TILES.length];
                return (
                  <li
                    key={m.name}
                    data-testid={`team-member-${m.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    <div className="aspect-[4/5] overflow-hidden bg-[#f4efe6]">
                      {m.img ? (
                        <img
                          src={m.img}
                          alt={m.name}
                          loading="lazy"
                          style={{
                            transform: m.scale ? `scale(${m.scale})` : undefined,
                            transformOrigin: m.origin || "center top",
                            objectPosition: m.objectPosition || "50% 0%",
                          }}
                          className="w-full h-full object-cover grayscale"
                        />
                      ) : (
                        <div
                          aria-hidden="true"
                          style={{ backgroundColor: t.bg, color: t.fg }}
                          className="w-full h-full flex items-center justify-center font-serif text-6xl tracking-tight"
                        >
                          {initials(m.name)}
                        </div>
                      )}
                    </div>
                    <p className="mt-5 font-mono text-[10px] tracking-[0.22em] uppercase text-[#2d4a22]">
                      {m.role}
                    </p>
                    <h3 className="mt-2 font-serif text-2xl leading-tight tracking-tight text-[#1a1a1a]">
                      {m.name}
                    </h3>
                  </li>
                );
              })}
            </ul>

            {/* Phulkopi & Hapot — the purpose */}
            <div
              data-testid="team-phulkopi-hapot"
              className="mt-10 bg-[#f9d94b] text-[#1a1a1a] p-5"
            >
              <div className="aspect-[4/5] overflow-hidden bg-[#1a1a1a]">
                <img
                  src="/phulkopi-hapot.jpg"
                  alt="Phulkopi & Hapot"
                  loading="lazy"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <p className="mt-5 font-mono text-[10px] tracking-[0.22em] uppercase text-[#1a1a1a]/70">
                Our babies
              </p>
              <h3 className="mt-2 font-serif text-2xl tracking-tight text-[#1a1a1a]">
                Phulkopi & Hapot
              </h3>
              <p className="mt-3 font-serif italic text-base leading-snug text-[#1a1a1a]">
                The purpose behind Stories by Aradhana.
              </p>
            </div>

            <div className="mt-12 border-t border-black/10 pt-6 font-mono text-[10px] tracking-[0.22em] uppercase text-[#1a1a1a]/60">
              Want to join the team? Write to{" "}
              <a
                href="mailto:hello@storiesbyaradhana.com"
                className="text-[#1a1a1a] underline underline-offset-4 decoration-[#1a1a1a]/30 hover:decoration-[#1a1a1a]"
              >
                hello@storiesbyaradhana.com
              </a>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
